import { CatalogRepository } from '../../domain/repositories/catalog.repository';
import { BannerRepository } from '../../domain/repositories/banner.repository';
import { ClientRepository } from '../../domain/repositories/client.repository';
import { BrandRepository } from '../../domain/repositories/brand.repository';
import { CategoryRepository } from '../../domain/repositories/category.repository';
import { SubCategoryRepository } from '../../domain/repositories/sub-category.repository';
import { QualityRepository } from '../../domain/repositories/quality.repository';
import { YoutubeLinkRepository } from '../../domain/repositories/youtube-link.repository';
import { HomeSlideRepository } from '../../domain/repositories/home-slide.repository';
import { ImageRepository } from '../../domain/repositories/image.repository';
import { HttpCatalogRepository } from '../../infrastructure/repositories/http-catalog.repository';
import { HttpBannerRepository } from '../../infrastructure/repositories/http-banner.repository';
import { HttpClientRepository } from '../../infrastructure/repositories/http-client.repository';
import { HttpBrandRepository } from '../../infrastructure/repositories/http-brand.repository';
import { HttpCategoryRepository } from '../../infrastructure/repositories/http-category.repository';
import { HttpSubCategoryRepository } from '../../infrastructure/repositories/http-sub-category.repository';
import { HttpQualityRepository } from '../../infrastructure/repositories/http-quality.repository';
import { HttpYoutubeLinkRepository } from '../../infrastructure/repositories/http-youtube-link.repository';
import { HttpHomeSlideRepository } from '../../infrastructure/repositories/http-home-slide.repository';
import { HttpImageRepository } from '../../infrastructure/repositories/http-image.repository';
import { PromotionRepository } from '../../domain/repositories/promotion.repository';
import { HttpPromotionRepository } from '../../infrastructure/repositories/http-promotion.repository';
import { AnalyticsRepository } from '../../domain/repositories/analytics.repository';
import { HttpAnalyticsRepository } from '../../infrastructure/repositories/http-analytics.repository';
import { getHttpClient } from './http-client.factory';
import { GetProductsUseCase } from '../../application/use-cases/get-products.use-case';
import { GetProductBySlugUseCase } from '../../application/use-cases/get-product-by-slug.use-case';
import { GetCategoriesUseCase } from '../../application/use-cases/get-categories.use-case';
import { CreateCategoryUseCase } from '../../application/use-cases/create-category.use-case';
import { UpdateCategoryUseCase } from '../../application/use-cases/update-category.use-case';
import { ToggleCategoryStatusUseCase } from '../../application/use-cases/toggle-category-status.use-case';
import { DeleteCategoryUseCase } from '../../application/use-cases/delete-category.use-case';
import { GetSubCategoriesUseCase } from '../../application/use-cases/get-sub-categories.use-case';
import { CreateSubCategoryUseCase } from '../../application/use-cases/create-sub-category.use-case';
import { UpdateSubCategoryUseCase } from '../../application/use-cases/update-sub-category.use-case';
import { ToggleSubCategoryStatusUseCase } from '../../application/use-cases/toggle-sub-category-status.use-case';
import { DeleteSubCategoryUseCase } from '../../application/use-cases/delete-sub-category.use-case';
import { GetQualitiesUseCase } from '../../application/use-cases/get-qualities.use-case';
import { CreateQualityUseCase } from '../../application/use-cases/create-quality.use-case';
import { UpdateQualityUseCase } from '../../application/use-cases/update-quality.use-case';
import { ToggleQualityStatusUseCase } from '../../application/use-cases/toggle-quality-status.use-case';
import { DeleteQualityUseCase } from '../../application/use-cases/delete-quality.use-case';
import { GetYoutubeLinksUseCase } from '../../application/use-cases/get-youtube-links.use-case';
import { CreateYoutubeLinkUseCase } from '../../application/use-cases/create-youtube-link.use-case';
import { UpdateYoutubeLinkUseCase } from '../../application/use-cases/update-youtube-link.use-case';
import { ToggleYoutubeLinkStatusUseCase } from '../../application/use-cases/toggle-youtube-link-status.use-case';
import { DeleteYoutubeLinkUseCase } from '../../application/use-cases/delete-youtube-link.use-case';
import { GetPromotionsUseCase } from '../../application/use-cases/get-promotions.use-case';
import { GetPublicPromotionsUseCase } from '../../application/use-cases/get-public-promotions.use-case';
import { GetPromotionByIdUseCase } from '../../application/use-cases/get-promotion-by-id.use-case';
import { CreatePromotionUseCase } from '../../application/use-cases/create-promotion.use-case';
import { UpdatePromotionUseCase } from '../../application/use-cases/update-promotion.use-case';
import { TogglePromotionStatusUseCase } from '../../application/use-cases/toggle-promotion-status.use-case';
import { DeletePromotionUseCase } from '../../application/use-cases/delete-promotion.use-case';
import {
  TrackProductViewUseCase,
  TrackSearchUseCase,
  TrackProductInquiryUseCase,
} from '../../application/use-cases/track-analytics.use-case';
import { GetAnalyticsDashboardUseCase } from '../../application/use-cases/get-analytics-dashboard.use-case';
import { GetAnalyticsRawDataUseCase } from '../../application/use-cases/get-analytics-raw-data.use-case';
import { GetFilterOptionsUseCase } from '../../application/use-cases/get-filter-options.use-case';
import { GetBannersUseCase } from '../../application/use-cases/get-banners.use-case';
import { SaveBannerUseCase } from '../../application/use-cases/save-banner.use-case';
import { ToggleBannerStatusUseCase } from '../../application/use-cases/toggle-banner-status.use-case';
import { GetBannerSettingsUseCase } from '../../application/use-cases/banners/get-banner-settings.use-case';
import { SaveBannerSettingsUseCase } from '../../application/use-cases/banners/save-banner-settings.use-case';
import { GetBrandsUseCase } from '../../application/use-cases/get-brands.use-case';
import { CreateBrandUseCase } from '../../application/use-cases/create-brand.use-case';
import { UpdateBrandUseCase } from '../../application/use-cases/update-brand.use-case';
import { ToggleBrandStatusUseCase } from '../../application/use-cases/toggle-brand-status.use-case';
import { DeleteBrandUseCase } from '../../application/use-cases/delete-brand.use-case';
import { GetClientsUseCase } from '../../application/use-cases/get-clients.use-case';
import { GetHomeSlidesUseCase } from '../../application/use-cases/get-home-slides.use-case';
import { SaveHomeSlideUseCase } from '../../application/use-cases/save-home-slide.use-case';
import { ToggleHomeSlideStatusUseCase } from '../../application/use-cases/toggle-home-slide-status.use-case';
import { DeleteHomeSlideUseCase } from '../../application/use-cases/delete-home-slide.use-case';
import { GetImagesUseCase } from '../../application/use-cases/get-images.use-case';
import { DeleteImageUseCase } from '../../application/use-cases/delete-image.use-case';

export interface CatalogUseCases {
  getProductsUseCase: GetProductsUseCase;
  getProductBySlugUseCase: GetProductBySlugUseCase;
  getCategoriesUseCase: GetCategoriesUseCase;
  createCategoryUseCase: CreateCategoryUseCase;
  updateCategoryUseCase: UpdateCategoryUseCase;
  toggleCategoryStatusUseCase: ToggleCategoryStatusUseCase;
  deleteCategoryUseCase: DeleteCategoryUseCase;
  categoryRepository: CategoryRepository;
  getSubCategoriesUseCase: GetSubCategoriesUseCase;
  createSubCategoryUseCase: CreateSubCategoryUseCase;
  updateSubCategoryUseCase: UpdateSubCategoryUseCase;
  toggleSubCategoryStatusUseCase: ToggleSubCategoryStatusUseCase;
  deleteSubCategoryUseCase: DeleteSubCategoryUseCase;
  subCategoryRepository: SubCategoryRepository;
  getQualitiesUseCase: GetQualitiesUseCase;
  createQualityUseCase: CreateQualityUseCase;
  updateQualityUseCase: UpdateQualityUseCase;
  toggleQualityStatusUseCase: ToggleQualityStatusUseCase;
  deleteQualityUseCase: DeleteQualityUseCase;
  qualityRepository: QualityRepository;
  getYoutubeLinksUseCase: GetYoutubeLinksUseCase;
  createYoutubeLinkUseCase: CreateYoutubeLinkUseCase;
  updateYoutubeLinkUseCase: UpdateYoutubeLinkUseCase;
  toggleYoutubeLinkStatusUseCase: ToggleYoutubeLinkStatusUseCase;
  deleteYoutubeLinkUseCase: DeleteYoutubeLinkUseCase;
  youtubeLinkRepository: YoutubeLinkRepository;
  getPromotionsUseCase: GetPromotionsUseCase;
  getPublicPromotionsUseCase: GetPublicPromotionsUseCase;
  getPromotionByIdUseCase: GetPromotionByIdUseCase;
  createPromotionUseCase: CreatePromotionUseCase;
  updatePromotionUseCase: UpdatePromotionUseCase;
  togglePromotionStatusUseCase: TogglePromotionStatusUseCase;
  deletePromotionUseCase: DeletePromotionUseCase;
  promotionRepository: PromotionRepository;
  getFilterOptionsUseCase: GetFilterOptionsUseCase;
  catalogRepository: CatalogRepository;
  getBannersUseCase: GetBannersUseCase;
  saveBannerUseCase: SaveBannerUseCase;
  toggleBannerStatusUseCase: ToggleBannerStatusUseCase;
  getBannerSettingsUseCase: GetBannerSettingsUseCase;
  saveBannerSettingsUseCase: SaveBannerSettingsUseCase;
  bannerRepository: BannerRepository;
  getBrandsUseCase: GetBrandsUseCase;
  createBrandUseCase: CreateBrandUseCase;
  updateBrandUseCase: UpdateBrandUseCase;
  toggleBrandStatusUseCase: ToggleBrandStatusUseCase;
  deleteBrandUseCase: DeleteBrandUseCase;
  brandRepository: BrandRepository;
  getClientsUseCase: GetClientsUseCase;
  clientRepository: ClientRepository;
  homeSlideRepository: HomeSlideRepository;
  getHomeSlidesUseCase: GetHomeSlidesUseCase;
  saveHomeSlideUseCase: SaveHomeSlideUseCase;
  toggleHomeSlideStatusUseCase: ToggleHomeSlideStatusUseCase;
  deleteHomeSlideUseCase: DeleteHomeSlideUseCase;
  imageRepository: ImageRepository;
  getImagesUseCase: GetImagesUseCase;
  deleteImageUseCase: DeleteImageUseCase;
  analyticsRepository: AnalyticsRepository;
  trackProductViewUseCase: TrackProductViewUseCase;
  trackSearchUseCase: TrackSearchUseCase;
  trackProductInquiryUseCase: TrackProductInquiryUseCase;
  getAnalyticsDashboardUseCase: GetAnalyticsDashboardUseCase;
  getAnalyticsRawDataUseCase: GetAnalyticsRawDataUseCase;
}

export const makeCatalogUseCases = (): CatalogUseCases => {
  const httpClient = getHttpClient();
  const catalogRepository = new HttpCatalogRepository(httpClient);
  const bannerRepository = new HttpBannerRepository(httpClient);
  const clientRepository = new HttpClientRepository(httpClient);
  const brandRepository = new HttpBrandRepository(httpClient);
  const categoryRepository = new HttpCategoryRepository(httpClient);
  const subCategoryRepository = new HttpSubCategoryRepository(httpClient);
  const qualityRepository = new HttpQualityRepository(httpClient);
  const youtubeLinkRepository = new HttpYoutubeLinkRepository(httpClient);
  const promotionRepository = new HttpPromotionRepository(httpClient);
  const analyticsRepository = new HttpAnalyticsRepository(httpClient);
  const homeSlideRepository = new HttpHomeSlideRepository(httpClient);
  const imageRepository = new HttpImageRepository(httpClient);

  return {
    getProductsUseCase: new GetProductsUseCase(catalogRepository),
    getProductBySlugUseCase: new GetProductBySlugUseCase(catalogRepository),
    getCategoriesUseCase: new GetCategoriesUseCase(categoryRepository),
    createCategoryUseCase: new CreateCategoryUseCase(categoryRepository),
    updateCategoryUseCase: new UpdateCategoryUseCase(categoryRepository),
    toggleCategoryStatusUseCase: new ToggleCategoryStatusUseCase(categoryRepository),
    deleteCategoryUseCase: new DeleteCategoryUseCase(categoryRepository),
    categoryRepository,
    getSubCategoriesUseCase: new GetSubCategoriesUseCase(subCategoryRepository),
    createSubCategoryUseCase: new CreateSubCategoryUseCase(subCategoryRepository),
    updateSubCategoryUseCase: new UpdateSubCategoryUseCase(subCategoryRepository),
    toggleSubCategoryStatusUseCase: new ToggleSubCategoryStatusUseCase(subCategoryRepository),
    deleteSubCategoryUseCase: new DeleteSubCategoryUseCase(subCategoryRepository),
    subCategoryRepository,
    getQualitiesUseCase: new GetQualitiesUseCase(qualityRepository),
    createQualityUseCase: new CreateQualityUseCase(qualityRepository),
    updateQualityUseCase: new UpdateQualityUseCase(qualityRepository),
    toggleQualityStatusUseCase: new ToggleQualityStatusUseCase(qualityRepository),
    deleteQualityUseCase: new DeleteQualityUseCase(qualityRepository),
    qualityRepository,
    getYoutubeLinksUseCase: new GetYoutubeLinksUseCase(youtubeLinkRepository),
    createYoutubeLinkUseCase: new CreateYoutubeLinkUseCase(youtubeLinkRepository),
    updateYoutubeLinkUseCase: new UpdateYoutubeLinkUseCase(youtubeLinkRepository),
    toggleYoutubeLinkStatusUseCase: new ToggleYoutubeLinkStatusUseCase(youtubeLinkRepository),
    deleteYoutubeLinkUseCase: new DeleteYoutubeLinkUseCase(youtubeLinkRepository),
    youtubeLinkRepository,
    getPromotionsUseCase: new GetPromotionsUseCase(promotionRepository),
    getPublicPromotionsUseCase: new GetPublicPromotionsUseCase(promotionRepository),
    getPromotionByIdUseCase: new GetPromotionByIdUseCase(promotionRepository),
    createPromotionUseCase: new CreatePromotionUseCase(promotionRepository),
    updatePromotionUseCase: new UpdatePromotionUseCase(promotionRepository),
    togglePromotionStatusUseCase: new TogglePromotionStatusUseCase(promotionRepository),
    deletePromotionUseCase: new DeletePromotionUseCase(promotionRepository),
    promotionRepository,
    getFilterOptionsUseCase: new GetFilterOptionsUseCase(catalogRepository),
    catalogRepository,
    getBannersUseCase: new GetBannersUseCase(bannerRepository),
    saveBannerUseCase: new SaveBannerUseCase(bannerRepository),
    toggleBannerStatusUseCase: new ToggleBannerStatusUseCase(bannerRepository),
    getBannerSettingsUseCase: new GetBannerSettingsUseCase(bannerRepository),
    saveBannerSettingsUseCase: new SaveBannerSettingsUseCase(bannerRepository),
    bannerRepository,
    getBrandsUseCase: new GetBrandsUseCase(brandRepository),
    createBrandUseCase: new CreateBrandUseCase(brandRepository),
    updateBrandUseCase: new UpdateBrandUseCase(brandRepository),
    toggleBrandStatusUseCase: new ToggleBrandStatusUseCase(brandRepository),
    deleteBrandUseCase: new DeleteBrandUseCase(brandRepository),
    brandRepository,
    getClientsUseCase: new GetClientsUseCase(clientRepository),
    clientRepository,
    homeSlideRepository,
    getHomeSlidesUseCase: new GetHomeSlidesUseCase(homeSlideRepository),
    saveHomeSlideUseCase: new SaveHomeSlideUseCase(homeSlideRepository),
    toggleHomeSlideStatusUseCase: new ToggleHomeSlideStatusUseCase(homeSlideRepository),
    deleteHomeSlideUseCase: new DeleteHomeSlideUseCase(homeSlideRepository),
    imageRepository,
    getImagesUseCase: new GetImagesUseCase(imageRepository),
    deleteImageUseCase: new DeleteImageUseCase(imageRepository),
    analyticsRepository,
    trackProductViewUseCase: new TrackProductViewUseCase(analyticsRepository),
    trackSearchUseCase: new TrackSearchUseCase(analyticsRepository),
    trackProductInquiryUseCase: new TrackProductInquiryUseCase(analyticsRepository),
    getAnalyticsDashboardUseCase: new GetAnalyticsDashboardUseCase(analyticsRepository),
    getAnalyticsRawDataUseCase: new GetAnalyticsRawDataUseCase(analyticsRepository),
  };
};
